import React, { useContext, useEffect, useMemo, useState } from "react";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import landingPerson from "../../assets/lottie/landingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import {illustration, greeting} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

function RotatingTagline({ phrases, isDark }) {
  const safePhrases = useMemo(
    () => (Array.isArray(phrases) && phrases.length > 0 ? phrases : []),
    [phrases]
  );
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (safePhrases.length <= 1) return;

    const interval = setInterval(() => {
      // fade out, switch text, fade in
      setVisible(false);
      setTimeout(() => {
        setIndex((i) => (i + 1) % safePhrases.length);
        setVisible(true);
      }, 220);
    }, 2600);

    return () => clearInterval(interval);
  }, [safePhrases]);

  if (safePhrases.length === 0) return null;

  return (
    <div className="greeting-tagline" aria-label="Professional tagline">
      <span
        className={
          (isDark ? "dark-mode " : "") +
          (visible ? "tagline-text" : "tagline-text tagline-text--hidden")
        }
      >
        {safePhrases[index]}
      </span>
    </div>
  );
}

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  if (!greeting.displayGreeting) {
    return null;
  }

  const resumeHref = greeting.resumeLink || require("./ggrigoriadis_cv.pdf");
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                {greeting.title}{" "}
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>

              {/* Animated / rotating professional tagline */}
              <RotatingTagline
                phrases={greeting.taglines}
                isDark={isDark}
              />

              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {greeting.subTitle}
              </p>

              {/* Professional summary highlights */}
              {Array.isArray(greeting.highlights) && greeting.highlights.length > 0 && (
                <div className={isDark ? "greeting-highlights dark-mode" : "greeting-highlights"}>
                  {greeting.highlights.map((h, i) => (
                    <div key={i} className="greeting-highlight">
                      <span className="greeting-highlight-icon" aria-hidden>
                        {h.icon}
                      </span>
                      <div className="greeting-highlight-text">
                        <div className="greeting-highlight-title">{h.title}</div>
                        {h.desc && (
                          <div className={isDark ? "dark-mode greeting-highlight-desc" : "greeting-highlight-desc"}>
                            {h.desc}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div id="resume" className="empty-div"></div>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="View Portfolio" href="#portfolio" />
                <Button text="Contact" href="#contact" />
                <Button
                  text="Download Resume"
                  href={resumeHref}
                  newTab={Boolean(greeting.resumeLink)}
                  download={!greeting.resumeLink ? "ggrigoriadis_cv.pdf" : undefined}
                />
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={landingPerson} />
            ) : (
              <img
                alt={greeting.title || "Portfolio logo"}
                src={greeting.logoImage}
                className="greeting-hero-image"
              ></img>
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
}
